import { call, put, takeEvery } from "redux-saga/effects";
import { xepTkbApi } from "../../../api/tkb/xepTkbApi";
import { ISuKienSelectRequest } from "../../../model/request/tkb/ISuKienSelectRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eXepTKBLopTCActionIds, IXepTKBLopTCActionTypes } from "../../action-types/tkb/IXepTKBLopTCActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.tkb.xepTKBLopTC;
export function* xepTKBLopTCSaga(): any {
  yield takeEvery(eXepTKBLopTCActionIds.LOAD_ALL_START, loadDataStart);

}

function* loadDataStart(action: IXepTKBLopTCActionTypes): any {
  const res: IBaseRespone = yield call(xepTkbApi.SelectXepTKBLopTC, action.payload as ISuKienSelectRequest);
  if (res.is_success) {
    yield put(mainAction.LOAD_ALL_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ALL_ERRR(res.message ?? "Có lỗi"));
  }
}
